import { render } from "./case-contact.vue?vue&type=template&id=09c24e9b&scoped=true&ts=true"
import script from "./case-contact.vue?vue&type=script&lang=ts"
export * from "./case-contact.vue?vue&type=script&lang=ts"

import "./case-contact.vue?vue&type=style&index=0&id=09c24e9b&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c24e9b"]])

export default __exports__